import ButtonClose from "../assets/images/button-close.png";
import ButtonInfo from "../assets/images/button-info.png";
import ButtonGroup from "../assets/images/button-group.png";
import ButtonFanpage from "../assets/images/button-fanpage.png";
import ButtonCommunity from "../assets/images/button-community.png";

import ButtonRecharge from "../assets/images/sidebar-button-recharge.png";

import ButtonPlaySidebar from "../assets/images/sidebar-button-play.png";

import HomeText from "../assets/images/home-text.png";
import HomeButton from "../assets/images/home-button.png";
import MobileHomeButton from "../assets/images/mobile-home-button.png";
import HomePlayButton from "../assets/images/play-button.png";

import HomeNewsBanner1 from "../assets/images/news-banner-1.jpg";
import HomeNewsBanner2 from "../assets/images/news-banner-2.jpg";
import HomeNewsBanner3 from "../assets/images/news-banner-3.jpg";

import HomePromotion1 from "../assets/images/promotion-nap-lan-dau.png";
import HomePromotion2 from "../assets/images/promotion-code-tan-thu.png";
import HomePromotion3 from "../assets/images/promotion-dan-tuong.png";

import HomeCTABackground from "../assets/images/update_022823/banner_group_bg.png";
import HomeCTAPlay from "../assets/images/update_022823/banner_play.png";
import HomeCTAApk from "../assets/images/update_022823/banner_apk.png";
import HomeCTAGoogle from "../assets/images/update_022823/banner_ggplay.png";
import HomeCTATopup from "../assets/images/update_022823/banner_topup.png";
import FloatingGooglePlay from "../assets/images/update_022823/floating_ggplay.png";

import FloatingTopup from "../assets/images/update_022823/floating_topup.png";
import FloatingBackground from "../assets/images/update_022823/floating_bg.png";
import FloatingGGPlay from "../assets/images/update_022823/floating_ggplay.png";
import FloatingAPK from "../assets/images/update_022823/floating_download_apk.png";
import QrCode from "../assets/images/update_022823/qr_code.svg";
import ButtonZalo from "../assets/images/update_022823/floating_zalo.png";
import ButtonFacebook from "../assets/images/update_022823/floating_fb.png";

const ImageStorage = {
  HomeCTABackground,
  HomeCTAPlay,
  HomeCTAApk,
  HomeCTAGoogle,
  HomeCTATopup,
  FloatingGooglePlay,
  FloatingTopup,
  FloatingBackground,
  FloatingGGPlay,
  FloatingAPK,

  ButtonClose,
  ButtonInfo,
  ButtonGroup,
  ButtonFanpage,
  ButtonCommunity,
  ButtonZalo,
  ButtonRecharge,
  ButtonFacebook,
  ButtonPlaySidebar,
  QrCode,

  HomeText,
  HomeButton,
  MobileHomeButton,
  HomePlayButton,

  HomeNewsBanner1,
  HomeNewsBanner2,
  HomeNewsBanner3,

  HomePromotion1,
  HomePromotion2,
  HomePromotion3,
};

export default ImageStorage;
